import type { CatalogItemFull } from "@albertine/types/openapi/lmt";
import { Lib } from "albertine-shared-web";
import { useHistory, useRouteMatch } from "react-router";
import { getCatalogItemKeyDetail } from "../../common/CatalogItem";
import { useMember } from "../../common/hooks/useMember";
import type { Request } from "../../common/types/Request";
import { useCatalogSelectionUrlParams } from "../../utils/customHook.util";
import routes from "../../utils/routes";
import Button from "../Common/Buttons";
import { PictogramIcon } from "../Common/Icon";
import InlineTextDelimiter from "../Common/InlineTextDelimiter";
import Label from "../Common/Label";
import Tag from "../Common/Tag";
import { CartButton } from "./Catalog";

type Props = {
    item: CatalogItemFull;
    cartItems: string[];
    selectCatalogItem?: (item: CatalogItemFull) => void;
    request?: Request;
    sendItemToCart?: (item: CatalogItemFull) => void;
};

function CatalogItemHeader({
    item,
    cartItems,
    selectCatalogItem,
    request,
    sendItemToCart,
}: Props) {
    const matchMemberId = useRouteMatch<{
        memberId: string;
    }>("/member/:memberId?")?.params.memberId;
    const memberId = matchMemberId || request?.member;

    const { data: member } = useMember(memberId);
    const history = useHistory();
    const { urlState } = useCatalogSelectionUrlParams();

    function goToEditMode(selectedItem: CatalogItemFull) {
        selectCatalogItem?.(selectedItem);
        history.push(
            routes.catalogEdit(
                urlState.context,
                selectedItem.id,
                request?.id,
                member?.id,
            ),
        );
    }

    const keyDetail = getCatalogItemKeyDetail(item);

    return (
        <>
            <h3>
                {item.name}
                {keyDetail && (
                    <Label.Medium.N50>
                        <InlineTextDelimiter />
                        {keyDetail}
                    </Label.Medium.N50>
                )}{" "}
                {item.archived && (
                    <>
                        <Tag.Small.Bold.E90>Archived</Tag.Small.Bold.E90>{" "}
                        <Tag.Small.Bold.N80>
                            Not visible to customers
                        </Tag.Small.Bold.N80>
                    </>
                )}
            </h3>

            <div>
                <Lib.Flex.Row gap="value16">
                    {item && cartItems && (
                        <CartButton
                            context={urlState.context}
                            currentItem={item}
                            cartItems={cartItems}
                            onClick={() => {
                                if (item) {
                                    sendItemToCart?.(item);
                                }
                            }}
                            member={member}
                        />
                    )}
                    <Button.Ghost
                        className="pictogram-icon--hover"
                        disabled={!item || item.archived}
                        onClick={() => {
                            if (item) {
                                goToEditMode(item);
                            }
                        }}
                    >
                        <PictogramIcon.Edit.Medium.N99 />
                    </Button.Ghost>
                </Lib.Flex.Row>
            </div>
        </>
    );
}

export default CatalogItemHeader;
